export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/484a06f5880a4b01c7c97ec83459f696.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-20 text-center w-full">
        <h1 className="text-7xl font-bold text-white mb-12 leading-tight tracking-tight">
          Secure Your<br />Digital Freedom
        </h1>
        <p className="text-xl text-gray-300 mb-16 font-light max-w-2xl mx-auto">
          Enterprise-grade VPN protection for your privacy
        </p>
        
        <button
          onClick={scrollToContact}
          className="group inline-flex items-center gap-4 bg-[#0066ff] text-white px-12 py-4 rounded-full text-base font-medium hover:shadow-[0_0_30px_rgba(0,102,255,0.5)] transition-all duration-300 hover:scale-105 active:scale-95 whitespace-nowrap"
        >
          Get Started
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-arrow-right-line text-xl"></i>
          </div>
        </button>
      </div>

      <div className="absolute bottom-20 right-20 w-96 h-96 opacity-30">
        <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0066ff" />
              <stop offset="100%" stopColor="#ff6b6b" />
            </linearGradient>
          </defs>
          <path d="M50,200 Q150,50 250,200 T450,200" fill="none" stroke="url(#lineGradient)" strokeWidth="2" />
          <path d="M50,250 Q150,100 250,250 T450,250" fill="none" stroke="url(#lineGradient)" strokeWidth="2" />
          <path d="M50,300 Q150,150 250,300 T450,300" fill="none" stroke="url(#lineGradient)" strokeWidth="2" />
        </svg>
      </div>
    </section>
  );
}
